import convertTxpBlobToObject from 'txp-data/lib/utils/data/convertTxpBlobToObject';
import isInvoiceSupported from '../utils/featureChecks/isInvoiceSupported';
import isServiceReservationSupported from '../utils/featureChecks/isServiceReservationSupported';
import { TxpObject } from 'txp-data';

export default function getTxpObjectFromTxpEntities(
    TxpEntities: string,
    entityNamesMap: number
): TxpObject {
    const isInvoiceEnabled = isInvoiceSupported(entityNamesMap);
    const isServiceReservationEnabled = isServiceReservationSupported(entityNamesMap);

    return convertTxpBlobToObject(TxpEntities, isInvoiceEnabled, isServiceReservationEnabled);
}
